<template>
  <div class="note">
    <small>
      Jeżeli chcesz przekazać nam jakieś informacje dotyczące projektu lub poszczególnych wersji, bądź ustalone zostały indywidualne zmiany.
      Prosimy o wpisanie tych informacji w polu poniżej.
    </small>
    <el-form style="margin-top: 20px" ref="form">
      <el-form-item>
        <el-input
          type="textarea"
          v-model="note"
          :autosize="{ minRows: 4, maxRows: 10 }"
          placeholder="Tutaj podaj wszystkie uwagi do tego projektu, ew. zmiany, które zostały z nami ustalone np. zmiana sznurka na złoty, zmiana koloru podklejenia na srebrny brokat."
          @change="handleNoteChange"
        >
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Note',
  props: ['sceneIndex'],
  data() {
    return {
      note: '',
    };
  },
  computed: {
    ...mapGetters('creator', ['scene']),
  },
  methods: {
    ...mapActions('creator', ['setNote']),

    handleNoteChange() {
      this.setNote({
        note: this.note,
        scene: this.sceneIndex
      })
    }
  },
  mounted() {
    this.note = this.scene.note
  }
};
</script>

<style lang="less">
.el-input-number.is-controls-right {
  width: 70px;
  max-width: 70px;
  .el-input__inner {
    padding-right: 35px;
    padding-left: 5px;
  }
}
textarea {
  width: 100%;
  max-width: 100%;
  border: 1px solid #ccc;
  padding: 5px 10px;
  box-sizing: border-box;
  border-radius: 3px;
  &::placeholder {
    font: 12px/16px 'Raleway';
  }
}
</style>
